import(/* webpackMode: "eager" */ "/app/apps/raz-v2/app/global-error.tsx");
